export default __webpack_public_path__ + "static/media/logo-zakopane.d125d00f.png";